import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'innerColor',
  pure: false
})
export class InnerColor implements PipeTransform {

    constructor(protected _sanitizer: DomSanitizer) {}
    transform(items): SafeHtml{
        return this._sanitizer.bypassSecurityTrustHtml(items);
    }
}